import { createAsyncThunk } from '@reduxjs/toolkit';
import { BooleanPropertyDTO } from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';

export const layerExplorerDefaultSelectionThunk = createAsyncThunk<boolean, string>(
  'layerExplorerDefaultSelectionThunk',
  async (propertyKey, thunkApi) => {
    try {
      const gpService = new GlobalPreferencesService();
      const result = await gpService.getProperty(propertyKey);
      return (result as BooleanPropertyDTO).value;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);
